import { polyfill as promisePolyfill } from 'es6-promise';
import { fetch as fetchPolyfill } from 'whatwg-fetch';

var setupPromisePolyfills = () => {
	promisePolyfill();
	fetchPolyfill();
}

export default setupPromisePolyfills;